module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Barthelemy-6f6409e1bdf7675123f7313d96724473.png";